import styled from 'styled-components'

export const TimeInput = styled.input`
    display: block;
    width: 100%;
    padding: 0.25rem;
`
